import {TextField} from '@material-ui/core'
import styled from 'styled-components'

export const PinCodeContainer = styled.div`
  flex-direction: row;
`;

export const PinCodeInputUnit = styled(TextField).attrs({
  maxLength: 1,
  variant: 'outlined',
  align: 'center',
  type: 'tel'
})`
  width: 40px;
  justify-content: center;
  align-items: center;
  margin-right: ${({last}) => (last ? '0px' : '4px')};
  & .MuiInputBase-input {
    text-align: center;
    font-size: 40px;
    height: 40px;
    padding-top: 0;
    padding-bottom: 0;
  }
`;
